module.exports = __webpack_public_path__ + "img/lock.5fccd08e.svg";